"use client";

import { Typography } from "@aph/ui-lib-humanx";
import React, { useEffect } from "react";
import styles from "./ArticleContent.module.scss";
import { getSlugName } from "@/helpers/getSlugName";
import { DeviceInfo } from "@/interface/deviceInfo";

interface ArticleContentProps {
  id?: string;
  articleLabel?: string;
  title?: string;
  subTitle?: string;
  className?: string;
  publisherName?: string;
  setSectionRef?: any;
  isPharma?: boolean;
  deviceType?: DeviceInfo;
}

const ArticleContent: React.FC<ArticleContentProps> = (props) => {
  const { id, title, subTitle, articleLabel, className = "", setSectionRef, isPharma = false, deviceType } = props;

  const slugName = getSlugName(title);
  const pharmaTopMargin = deviceType?.isMobile ? 70 : 180;
  const topMargin = deviceType?.isMobile ? 62 : 103;

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const id = hash.substring(1); 
        const element = document.getElementById(id);
        
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className={`${styles.articleRoot} ${className}`} id={slugName} 
    style={{ scrollMarginTop: isPharma ? pharmaTopMargin: topMargin, scrollBehavior: "smooth" }}
    >
      <div
        className={styles.topSection}
        id={`table-item-${id}`}
        ref={setSectionRef ? setSectionRef(`table-item-${id}`) : null}
      >
        <label className={styles.label}>{articleLabel}</label>

        {title && (
          isPharma ?
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} id={`table-item-title-${id}`} />
            :
            <Typography component="h2" className={styles.title}>
              <div dangerouslySetInnerHTML={{ __html: title }} id={`table-item-title-${id}`} />
            </Typography>
        )}
        {subTitle && <div dangerouslySetInnerHTML={{ __html: subTitle }} className={styles.subTitle} />}
      </div>
    </div>
  );
};

export default ArticleContent;
